import { Button, Flex } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import * as React from 'react';
import { Link, Outlet } from 'react-router-dom';

import EmptyStub from '@/components/ui/EmptyStub';
import Loader from '@/components/ui/Loader';
import { ROUTES } from '@/configs/routes';
import { useDevices } from '@/utils/devices';

import s from './OrganizationLayoutContent.module.scss';

type OrganizationLayoutContentProps = {
  isSectionsConfigLoading: boolean;
  isSectionsConfigError: boolean;
  showNoSectionsStub: boolean;
  onRetryLoadSections: () => void;
};

const OrganizationLayoutContent: React.FC<OrganizationLayoutContentProps> = ({
  isSectionsConfigLoading,
  isSectionsConfigError,
  showNoSectionsStub,
  onRetryLoadSections,
}) => {
  const { isCompactViewport } = useDevices();

  if (isSectionsConfigLoading) {
    return <Loader type="dots" fullHeight />;
  }

  if (showNoSectionsStub) {
    return (
      <EmptyStub
        picture={<IconAlertTriangle className={s['root__stub-picture']} size={100} />}
        className={s.root__stub}
        title="Нет доступных разделов"
        description="Проверьте видимость разделов в настройках организации."
        action={
          <Flex className={s['root__stub-actions']} justify="center" gap="xs">
            <Button component={Link} to={ROUTES.root.path} replace size={isCompactViewport ? 'xs' : 'sm'}>
              На главную
            </Button>
          </Flex>
        }
      />
    );
  }

  if (isSectionsConfigError) {
    return (
      <EmptyStub
        picture={<IconAlertTriangle className={s['root__stub-picture']} size={100} />}
        className={s.root__stub}
        title="Не удалось загрузить разделы"
        description="Проверьте видимость разделов в настройках организации и попробуйте снова."
        action={
          <Flex className={s['root__stub-actions']} justify="center" gap="xs">
            <Button onClick={onRetryLoadSections} size={isCompactViewport ? 'xs' : 'sm'}>
              Повторить
            </Button>
            <Button
              component={Link}
              to={ROUTES.root.path}
              replace
              size={isCompactViewport ? 'xs' : 'sm'}
              variant="light"
            >
              На главную
            </Button>
          </Flex>
        }
      />
    );
  }

  return <Outlet />;
};

export default React.memo(OrganizationLayoutContent);
